/* CloudSecurityParticipantBadge.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["showAetherAppListingPage"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"],
  _excluded7 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _21 = "._p12fhhrg{max-width:11rem}";
const _20 = "._18u0u2gc{margin-left:var(--ds-space-100,8px)}";
const _19 = "._p12f1ltq{max-width:16rem}";
const _18 = "._4cvr1kw7{align-items:inherit}";
const _17 = "._1e0c1txw{display:flex}";
const _16 = "._18s8vjyi{margin:0 0 var(--ds-space-150,9pt)}";
const _15 = "._1kba1h6o._1kba1h6o{align-items:center}";
const _14 = "._if291txw._if291txw{display:flex}";
const _13 = "._w1ap1osq._w1ap1osq{width:100%}";
const _12 = "._kkk2n7od{all:unset}";
const _11 = "._k48p1nn1{font-weight:400}";
const _10 = "._k48pni7l{font-weight:600}";
const _9 = "._syaz1fxt{color:var(--ds-text,#172b4d)}";
const _8 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const _7 = "._1wyboqnp{font-size:.75rem}";
const _6 = "._o5721q9c{white-space:nowrap}";
const _5 = "._1ccqt94y{word-spacing:1px}";
const _4 = "._18u0v77o{margin-left:var(--ds-space-025,2px)}";
const _3 = "._1p1dangw{text-transform:uppercase}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// eslint-disable-next-line import/no-named-as-default
import { B400, N500 } from '@atlaskit/theme/colors';
import { Link } from '@atlassian/amkt-common';
import React from 'react';
import RichTooltip from '../../primitives/RichTooltip';
import { TEST_IDS } from '../../primitives/testIds';
import CheckCircleIconGreen from '../CheckCircleIconGreen';
import CloudSecurityParticipantIcon from '../CloudSecurityParticipantIcon';
import CloudSecurityParticipantTooltipV2 from './CloudSecurityParticipantTooltipV2';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _2 = "._otyru2gc{margin-bottom:var(--ds-space-100,8px)}";
const _ = "._19pkidpf{margin-top:0}";
const StyledParagraph = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "p",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _otyru2gc", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  StyledParagraph.displayName = 'StyledParagraph';
}
const BadgeText = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  const {
      showAetherAppListingPage
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_3, _4, _5, _6, _7, _8, _9, _10, _11]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1p1dangw _18u0v77o _1ccqt94y _o5721q9c _1wyboqnp", __cmplp.showAetherAppListingPage ? "_syaz1gjq" : "_syaz1fxt", __cmplp.showAetherAppListingPage ? "_k48pni7l" : "_k48p1nn1", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  BadgeText.displayName = 'BadgeText';
}
const BadgeContainer = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_12, _13, _14, _15]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_kkk2n7od _w1ap1osq _if291txw _1kba1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  BadgeContainer.displayName = 'BadgeContainer';
}
const P = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "p",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_16, _17, _18]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_18s8vjyi _1e0c1txw _4cvr1kw7", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  P.displayName = 'P';
}
const TooltipContainer = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_19, _9]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_p12f1ltq _syaz1fxt", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TooltipContainer.displayName = 'TooltipContainer';
}
const Span = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded7);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_20, _21]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_18u0u2gc _p12fhhrg", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Span.displayName = 'Span';
}
export const CloudSecurityParticipantIconColor = {
  primary: "var(--ds-icon-brand, ".concat(B400, ")"),
  secondary: "var(--ds-icon, ".concat(N500, ")")
};
export const CLOUD_SECURITY_BADGE_LABEL = 'Cloud Security Participant';
export default function CloudSecurityParticipantBadge(_ref7) {
  let {
    className,
    showLabel,
    iconSize,
    iconColor,
    showAetherAppListingPage
  } = _ref7;
  const badgeIconColor = iconColor ? iconColor : CloudSecurityParticipantIconColor.primary;
  if (!showLabel) {
    return /*#__PURE__*/_jsx(CloudSecurityParticipantIcon, {
      label: "",
      size: iconSize,
      primaryColor: badgeIconColor,
      testId: "cloud-security-participant-icon"
    });
  }
  const stopEventPropagation = e => e.stopPropagation();
  const link = 'https://www.atlassian.com/licensing/marketplace#what-is-the-marketplace-bug-bounty-program';
  const tooltipContent = /*#__PURE__*/_jsxs(TooltipContainer, {
    "data-testid": TEST_IDS.CLOUD_SECURITY_PARTICIPANT_TOOLTIP,
    children: [/*#__PURE__*/_jsxs(StyledParagraph, {
      children: [/*#__PURE__*/_jsx("b", {
        children: "Cloud Security participant"
      }), " apps offer verified security through:"]
    }), /*#__PURE__*/_jsxs(P, {
      children: [/*#__PURE__*/_jsx(CheckCircleIconGreen, {}), /*#__PURE__*/_jsx(Span, {
        children: "Participation in the Marketplace Bug Bounty program"
      })]
    }), /*#__PURE__*/_jsx(Link, {
      target: "_blank",
      href: link,
      onClick: stopEventPropagation,
      children: "Learn about the Marketplace Bug Bounty program"
    })]
  });
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(RichTooltip, {
      content: showAetherAppListingPage ? /*#__PURE__*/_jsx(CloudSecurityParticipantTooltipV2, {
        learnMoreLink: link
      }) : tooltipContent,
      children: /*#__PURE__*/_jsxs(BadgeContainer, {
        tabIndex: -1,
        className: className,
        onClick: stopEventPropagation,
        children: [/*#__PURE__*/_jsx(CloudSecurityParticipantIcon, {
          label: "",
          size: iconSize,
          primaryColor: badgeIconColor,
          showAetherAppListingPage: showAetherAppListingPage,
          testId: "cloud-security-participant-icon"
        }), /*#__PURE__*/_jsx(BadgeText, {
          showAetherAppListingPage: showAetherAppListingPage,
          children: CLOUD_SECURITY_BADGE_LABEL
        })]
      })
    })
  });
}